




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getAppleAppStoreLink, getGooglePlayStoreLink } from '@utils/analytics';
import FooterDisclaimer from './footer-disclaimer.vue';
import { Link } from 'types/layout';

@Component({
	components: {
		FooterDisclaimer
	}
})
export default class FooterFull extends Vue {
	@Prop({ default: null })
	footnotes!: Array<string>;

	footerLogo = `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/interface/logo-glyph-white.svg`;

	appStoreLogo = `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/images/marketing-site/button-appstore-gray.svg`;

	googlePlayLogo = `${process.env.VUE_APP_CLOUDFRONT_DOMAIN}/images/marketing-site/button-googleplay-gray.svg`;

	appStoreLink = getAppleAppStoreLink('site_footer');
	playStoreLink = getGooglePlayStoreLink('site_footer');

	contactLink: Link = {
		text: 'Contact Us',
		href: '/contact'
	};

	links: Record<string, Array<Link>> = {
		Product: [
			{
				text: 'How it works',
				router: 'how-it-works'
			},
			{
				text: 'Client returns',
				router: 'client-returns'
			},
			{
				text: 'Strategy',
				router: 'strategy'
			},
			{
				text: 'Real estate',
				router: 'assets'
			}
		],
		Company: [
			{
				text: 'About us',
				router: 'about'
			},
			{
				text: 'Press',
				router: 'press'
			},
			{
				text: 'Careers',
				router: 'careers'
			}
		],
		Resources: [
			{
				text: 'Help center',
				href: '/help'
			},
			{
				text: 'Articles',
				href: '/education/blog'
			},
			{
				text: 'Engineering blog',
				href: 'https://medium.com/fundrise-engineering',
				target: '_blank',
				rel: 'noopener noreferrer'
			}
		]
	};

	socialMediaLinks: Array<Link> = [
		{
			text: 'linkedin',
			href: 'https://www.linkedin.com/company/fundrise',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		{
			text: 'facebook',
			href: 'http://facebook.com/fundrise',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		{
			text: 'instagram',
			href: 'http://instagram.com/fundrise',
			target: '_blank',
			rel: 'noopener noreferrer'
		},
		{
			text: 'twitter',
			href: 'http://twitter.com/fundrise',
			target: '_blank',
			rel: 'noopener noreferrer'
		}
	];
}
